export default __webpack_public_path__ + "static/diff-504eb20836cfe8d31a38572467ce09bc.png";